import { render, staticRenderFns } from "./GMultiSelect.vue?vue&type=template&id=7513d619"
import script from "./GMultiSelect.vue?vue&type=script&lang=js"
export * from "./GMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./GMultiSelect.vue?vue&type=style&index=0&id=7513d619&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports